// src/components/card/Coach.tsx

import { Alert, Box, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { UserId } from '@/types/domain'

import { useUserApi } from '../../hooks'

type Props = {
  bridgeId: UserId
}

export const Coach = ({ bridgeId }: Props) => {
  const [coachData, setCoachData] = useState(null)
  const { getCoachData } = useUserApi()

  useEffect(() => {
    const getCoach = async id => {
      const data = await getCoachData(id)
      setCoachData(data)
    }

    getCoach(bridgeId)
  }, [bridgeId, getCoachData])

  const theme = useTheme()
  const color = theme.palette.primary.main

  if (!bridgeId || !coachData?.attributes) return <Box />

  const { email_contact, firstname, lastname, telephone, telephone_mobile } =
    coachData.attributes

  return (
    <Alert severity={'info'} icon={false} sx={{ mb: 5 }}>
      <Typography
        sx={{
          letterSpacing: 2,
          fontWeight: 'bold',
          mb: 2,
        }}
      >
        {firstname} {lastname}
      </Typography>
      <Typography>
        Telefon:{' '}
        {telephone ? (
          <Link style={{ color }} to={`tel:${telephone}`}>
            {telephone}
          </Link>
        ) : (
          '-'
        )}
      </Typography>
      <Typography>
        Mobil:{' '}
        {telephone_mobile ? (
          <Link style={{ color }} to={`tel:${telephone_mobile}`}>
            {telephone_mobile}
          </Link>
        ) : (
          '-'
        )}
      </Typography>
      <Typography>
        Mail:{' '}
        {email_contact ? (
          <Link style={{ color }} to={`mailto:${email_contact}`}>
            {email_contact}
          </Link>
        ) : (
          '-'
        )}
      </Typography>
    </Alert>
  )
}
